import * as ContenantActions from './../actions/contenants.actions';
import { IContenant } from './../../interfaces/models';

export type Action = ContenantActions.All;

// Reducer function
export function contenantsReducer(data: IContenant[] = [], action: Action) {
  switch (action.type) {
    case ContenantActions.SET: {
      return action.data;
    }
    case ContenantActions.EDIT: {
      data.forEach((c: IContenant, index) => {
        if (c.id === action.data.id) {
          data[index] = action.data;
        }
      });

      return [...data];
    }
    case ContenantActions.ADD: {
      return [action.data, ...data];
    }
    case ContenantActions.DELETE: {
      const newData = data.filter((c: IContenant) => {
        return c.id !== action.id;
      });

      console.log(newData);
      return newData;
    }
    case ContenantActions.OPEN_MODAL: {
      return true;
    }
    case ContenantActions.CLOSE_MODAL: {
      return false;
    }
    default: {
      return data;
    }
  }
}
